import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const BinIcon = ({ sx, ...props }: SvgIconProps) => {
  const colors: Record<string, string> = {
    warning: '#FF5F57',
    info: 'white',
    secondary: '#14191F66',
  };

  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ height: '16px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4"
        stroke={colors[props.color] ?? '#14191F'}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default BinIcon;
